import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ToastModule } from 'primeng/toast';
import { FeatureToggleService } from '@lib/feature-toggle/data-access';
import { FeatureToggleType } from '@lib/feature-toggle/models';
import { ToastMessageOptions } from 'primeng/api';
import { AuthService } from '@lib/auth/data-access';
import { RouterLinkSafeUrlPipe, UrlSegmentPipe } from '@lib/shared/util';
import { NotificationCategory } from '@lib/notification/models';

@Component({
  selector: 'lib-notification-feature-incident-review-notification',
  standalone: true,
  imports: [
    RouterLinkSafeUrlPipe,
    RouterModule,
    ToastModule,
    AvatarModule,
    AvatarGroupModule,
    UrlSegmentPipe
],
  templateUrl: './incident-review-notification.component.html',
  styleUrl: './incident-review-notification.component.scss',
})
export class IncidentReviewNotificationComponent {
  message = input.required<ToastMessageOptions>();
    
  // inject
  private router = inject(Router);
  private featureToggleService = inject(FeatureToggleService);
  public authService = inject(AuthService);
  public NotificationCategory = NotificationCategory;
  
  // public
  public isNotificationFeatureEnabled = computed(() => { return this.featureToggleService.tenantFeaturesComputedSignal().some(feature => feature.id === FeatureToggleType.Notifications && feature.isEnabled) })


  navigateToReview(incidentReportId: number) {
    this.router.navigateByUrl(`t/${this.authService.userPrincipalComputedSignal()?.currentTenantExternalId}/reviews/incidents/${incidentReportId}`);
  }

  navigateToIncident(incidentReportId: number) {
    this.router.navigateByUrl(`t/${this.authService.userPrincipalComputedSignal()?.currentTenantExternalId}/incidents/${incidentReportId}`);
  }
}

